import React,{useEffect, useState} from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import { makeStyles } from '@material-ui/core/styles';
import styles from "../../../LeftNavigation/DesignerControls/BasicControls.module.css"
import ControlsMap from '../../../Properties/PropertiesConfiguration'
import CollapsibleComponent from './CollapsibleComponentforBackdrop'
import ToggleBtn from "../../../../ReusableComponents/ToggleBtn/ToggleBtn"
import ColorPicker from "../../../../ReusableComponents/ColorPicker/ColorPicker"
import {Button} from 'react-bootstrap'
import { createUniqueId } from '../../IFormDesignerLogic';
import ColumnFromPageIcon from "../../../../Icons/ColumnFromPageIcon"
import  {ThemeJSON} from '../../Theme/ThemeJSON';
import axios from '../../../../axios'

const useStyles = makeStyles((theme) => ({
 backdrop: {
 zIndex: 200,
 color: '#fff',
 },
}));
 
function TableBackdropColumnDetails(props) {
  
    function toBeRemovedOnUncomment(){
    // const[propertiesJson, setPropertiesJson] = useState(props.selectedColumn ? props.selectedColumn.style : {})
    // const [oldProperties,setOldProperties] = useState(props.selectedColumn ? Object.assign({},props.selectedColumn.style) : {})
    // const ColumnPropertiesJson = props.columnPropertiesJson;
    // const [widthType, setWidthType] =  useState("%");
   

    // function handleCombo(comboId){
    //    var select = document.getElementById(comboId);
    //    var propertyName = select.getAttribute("name");
    //    var optionTag = select.options[select.selectedIndex];
    //    if(propertyName.toLowerCase() === "columnwidthtype"){
    //         if(optionTag.value==="percentage"){
    //             setWidthType("%");
    //         }
    //         else{
    //             setWidthType("px");
    //         }
    //    }
    //    else {
    //         handleProperty(propertyName, optionTag.value);
    //    }
       
    // }

    // function handleProperty(propertyName, propertyValue){ 
    //     console.log(propertyName, propertyValue);
    //     if(propertyName.toLowerCase()==="tooltip"){
    //         if(propertyValue.trim().length<1){
    //             return ;
    //         }
    //     } 
    //     var json = props.selectedColumn.style;
    //     json[propertyName] = propertyValue;

    //     props.selectedColumn.style= json;
    //     setPropertiesJson((prev)=>{return{...prev,[propertyName]:propertyValue}});
    // }
    // function handleColumnWidth(propertyName, propertyValue){ 
    //     var value = propertyValue; console.log(propertyName,value);
    //     if(propertyName ==="width"){
    //         if(widthType === "%")
    //             value = value+"%";
    //         else if(widthType === "px")
    //             value = value+"px";
    //     }
        
    // } 
     
    // var CollapsibleItems = [];
    // var BasicDetailsLeftSide = [];
    // var BasicDetailsRightSide = [];
    // var BasicDetailsBottom = [];
    // var inputValidationsLeft = [];
    // var inputValidationsRight = [];
    // var appearanceLeft = [];
    // var appearanceRight = [];

    //     if(props.selectedColumn && props.selectedColumn !==null) {  
    //         Object.keys(ColumnPropertiesJson).map((key,index)=>{
    //             var collapseComponentBody = [];
    //             if(key === "Basic"){
    //                 Object.keys(ColumnPropertiesJson[key]).map((property)=>{
    //                     if(ControlsMap[property].type){
    //                         if(ControlsMap[property].alignment==="left"){
    //                             BasicDetailsLeftSide.push(prepareHtmlTag(property,ControlsMap[property].type,ControlsMap[property]["styleKey"],ControlsMap[property].alignment));
    //                         }else if(ControlsMap[property].alignment==="right"){
    //                             BasicDetailsRightSide.push(prepareHtmlTag(property,ControlsMap[property].type,ControlsMap[property]["styleKey"],ControlsMap[property].alignment));
    //                         }else{
    //                             BasicDetailsBottom.push(prepareHtmlTag(property,ControlsMap[property].type,ControlsMap[property]["styleKey"],ControlsMap[property].alignment));
    //                         } 
    //                     }
    //                 })   
    //             }
    //             else if(key==="InputValidations"){
    //                         Object.keys(ColumnPropertiesJson[key]).map((property)=>{
    //                         if(ControlsMap[property] && ControlsMap[property] && ControlsMap[property].alignment==="left"){
    //                             inputValidationsLeft.push(prepareHtmlTag(property,ControlsMap[property].type,ControlsMap[property]["styleKey"],ControlsMap[property].alignment));
    //                         }else if(ControlsMap[property] && ControlsMap[property].alignment==="right"){
    //                             inputValidationsRight.push(prepareHtmlTag(property,ControlsMap[property].type,ControlsMap[property]["styleKey"],ControlsMap[property].alignment));
    //                         }
    //                     })
    //                     if(CollapsibleItems=== []){
    //                         CollapsibleItems.push(<CollapsibleComponent id={index+""} heading={key} leftBody={inputValidationsLeft} rightBody={inputValidationsRight}/>);
    //                     }
    //                     CollapsibleItems.push(<CollapsibleComponent id={index+""} heading={key} leftBody={inputValidationsLeft} rightBody={inputValidationsRight}/>);
    //             }
    //             else {
    //                 Object.keys(ColumnPropertiesJson[key]).map((property)=>{
    //                     if(ControlsMap[property] && ControlsMap[property].alignment==="left"){
    //                             appearanceLeft.push(prepareHtmlTag(property,ControlsMap[property].type,ControlsMap[property]["styleKey"],ControlsMap[property].alignment));
    //                         }else if(ControlsMap[property] && ControlsMap[property].alignment==="right"){
    //                             appearanceRight.push(prepareHtmlTag(property,ControlsMap[property].type,ControlsMap[property]["styleKey"],ControlsMap[property].alignment));
    //                         }
    //              })
    //                 if(CollapsibleItems=== []){
    //                     CollapsibleItems.push(<CollapsibleComponent id={index+""} heading={key} leftBody={appearanceLeft} rightBody={appearanceRight}/>);
    //                 }
    //                 CollapsibleItems.push(<CollapsibleComponent id={index+""} heading={key} leftBody={appearanceLeft} rightBody={appearanceRight}/>);
    //             }
                
    //         });console.log("called");
    //     }
   

    // function prepareHtmlTag(key,type,styleKey,alignment) {
        
    //         switch(type.toLowerCase()){
    //             case "combo" :
    //                     return (
    //                     <div className={alignment === "left" ? styles.colParentDiv : styles.colParentDiv2}>
    //                         <span className={alignment === "left" ? styles.columnPropertyName : styles.columnPropertyName2}>{ControlsMap[key].label}</span>
    //                             <select className={alignment === "left" ? styles.colPropertyValueInput : styles.colPropertyValueInput4} name={key} id={key} onChange={()=>handleCombo(key)}>
    //                              {ControlsMap[key].children.map((optionTagData,optionCount)=>{
    //                                 if(ControlsMap[key].children[optionCount].Value ===  propertiesJson[key]){
    //                                     return <option value={ControlsMap[key].children[optionCount].Value} selected>{ControlsMap[key].children[optionCount].Title}</option>
    //                                 }else {
    //                                     return <option value={ControlsMap[key].children[optionCount].Value}>{ControlsMap[key].children[optionCount].Title}</option>
    //                                 }
    //                             })}
    //                            </select>
    //                    </div>     
    //                      )
    //                     case "smallcombo" :
    //                     return (
    //                     <div className={alignment === "left" ? styles.colParentDiv5 : styles.colParentDiv5}>
    //                         <span className={alignment === "left" ? styles.columnPropertyName : styles.columnPropertyName2}>{ControlsMap[key].label}</span>
    //                             <select className={alignment === "left" ? styles.colPropertyValueInput5 : styles.colPropertyValueInput5} name={key} id={key} onChange={()=>handleCombo(key)}>
    //                              {ControlsMap[key].children.map((optionTagData,optionCount)=>{
    //                                 if(ControlsMap[key].children[optionCount].Value ===  propertiesJson[key]){
    //                                     return <option value={ControlsMap[key].children[optionCount].Value} selected>{ControlsMap[key].children[optionCount].Title}</option>
    //                                 }else {
    //                                     return <option value={ControlsMap[key].children[optionCount].Value}>{ControlsMap[key].children[optionCount].Title}</option>
    //                                 }
    //                             })}
    //                            </select>
    //                    </div>     
    //                      )
    //             case "text" : return( 
    //                     <div className={alignment === "left" ? styles.colParentDiv : styles.colParentDiv2}>
    //                     <span className={alignment === "left" ? styles.columnPropertyName : styles.columnPropertyName2}>{ControlsMap[key].label}</span>
    //                     <input type="text" defaultValue={ propertiesJson ? propertiesJson[styleKey] : null} className={alignment === "left" ? styles.colPropertyValueInput : styles.colPropertyValueInput4} onChange={(event)=>handleProperty(styleKey,event.target.value)}/>
    //                     </div>
    //             )
    //             case "checkbox" :  return(
    //                     <div className={styles.["columnBasisDetails" + alignment]}>
    //                         <input type = "checkbox"
    //                          defaultChecked= { propertiesJson[styleKey]==="true" ? true : false}
    //                          onChange={(event)=>handleProperty(key, propertiesJson[key]==="true" ? "false" : "true")}/>
    //                         <span className={styles.checkBoxSpan}>{ControlsMap[key].label}</span>
    //                     </div>
    //             )
    //             case "smalltext" : return( 
    //                     <div className={alignment === "left" ? styles.colParentDiv : styles.colParentDiv5}>
    //                     <span className={alignment === "left" ? styles.columnPropertyName : styles.columnPropertyName2}>{ControlsMap[key].label}</span>
    //                     <input type="text" defaultValue={ propertiesJson[styleKey]} className={alignment === "left" ? styles.colPropertyValueInput : styles.colPropertyValueInput5}  onChange={(event)=>handleProperty(styleKey,event.target.value)}/>
    //                     </div>
    //             )

    //             case "colorpicker" : return(
                    
    //                 <div className={styles.colParentDiv5}>
    //                     <span className={alignment === "left" ? styles.leftLabel1 : styles.leftLabel2}>{ControlsMap[key].label}</span>
    //                     <div className={alignment === "left" ? styles.RightLabelColorPickerDiv3 : styles.RightLabelColorPickerDiv3}>
    //                    <ColorPicker  color={props.selectedColumn && props.selectedColumn.style ? props.selectedColumn.style[key] : null} handleProperty={handleProperty} propertyName={key} />
    //                    </div>
    //                 </div>
    //             )

    //             case "toggle" : return(<>
    //             <div className={styles.colParentDiv4}>
    //                     <span className={styles.columnPropertyName} >{ControlsMap[key].label}</span>
    //                   <div className={styles.colPropertyToggle}> <ToggleBtn handleToggle={(value,e)=>handleProperty(styleKey, value)} toggleState={propertiesJson[styleKey]} field={styleKey}/> </div>
    //             </div>
    //             {styleKey === "AllowSpecialChars" ? (propertiesJson && propertiesJson[styleKey] && propertiesJson[styleKey].toLowerCase() === "y") ||  (propertiesJson && propertiesJson[styleKey] && propertiesJson[styleKey].toLowerCase() === "true") ?
    //             <div><input type="text" defaultValue={propertiesJson[styleKey]} className={alignment === "left" ? styles.colFullWidthText : styles.colPropertyValueInput4}  onChange={(event)=>handleProperty(styleKey,event.target.value)}/>
    //             </div>:<div><input type="text" defaultValue={propertiesJson[styleKey]} className={alignment === "left" ? styles.colFullWidthText : styles.colPropertyValueInput4}  disabled />
    //             </div> : null}</>
    //             )

    //             case "combotext" : return(
    //             <div className={styles.colParentDiv}>
    //                         <span className={styles.columnPropertyName}>{ControlsMap[key].label}</span>
    //                             <select name={key+"Type"} id={key+"Type"} className={styles.colPropertyValueInput2} onChange={()=>handleCombo(key+"Type")}>
    //                              {ControlsMap[key].children.map((optionTagData,optionCount)=>{
    //                                 if(ControlsMap[key].children[optionCount].Value ===  propertiesJson[key+"Type"]){
    //                                     return <option value={ControlsMap[key].children[optionCount].Value} selected>{ControlsMap[key].children[optionCount].Title}</option>
    //                                 }else {
    //                                     return <option value={ControlsMap[key].children[optionCount].Value}>{ControlsMap[key].children[optionCount].Title}</option>
    //                                 }
    //                             })}
    //                             </select>
    //                             <input type="text" defaultValue={ propertiesJson[styleKey] } className={styles.colPropertyValueInput3} onChange={(event)=>handleColumnWidth(styleKey, event.target.value)}/>
    //                     </div>
    //             )     
    //             case "header" : return(
    //                 <p className={alignment === "left" ? styles.propertiesHeader2 : styles.propertiesHeader3}>{ControlsMap[key].label}</p>
    //             )       
    //     }

    // }
    }

        return (
            <>
                <div className={styles.columnBasisDetailsDiv} >
                    <div className={styles.columnBasisDetailsLeftDiv}>
                        {props && props.BasicDetailsLeftSide && props.BasicDetailsLeftSide !==null ?
                            props.BasicDetailsLeftSide.map((item)=>{
                                if(item && item != null){
                                    return item;
                                } 
                            })
                        :  null}
                    </div> 
                    <div style={{marginTop:"1px"}} className={styles.columnBasisDetailsRightDiv}>
                        {props && props.BasicDetailsRightSide && props.BasicDetailsRightSide !==null ?
                                props.BasicDetailsRightSide.map((item)=>{
                                    if(item && item != null){
                                        return item;
                                    } 
                                })
                        :  null}
                    </div>
                    <div className={styles.bottomDiv}>
                        {props && props.BasicDetailsBottom && props.BasicDetailsBottom !==null ?
                                props.BasicDetailsBottom.map((item)=>{
                                    if(item && item != null){
                                        return item;
                                    } 
                                })
                        :  null}
                    </div> 
                </div> 
                {/* <div style={{color:"transparent"}}>sometext</div> */}
                <div className={styles.columnCollapsibleProperties}>
                    {props && props.CollapsibleItems && props.CollapsibleItems !==null ?
                            props.CollapsibleItems.map((item)=>{
                                if(item && item != null){
                                    return item;
                                }     
                            }) 
                    :  null}    
                </div>
            </>
    );
}
export default TableBackdropColumnDetails;